import {Color} from '@/Types/Enums/Color'
import {type RotationVoter} from '@/Types/Periods/Rotations/RotationVoter'
import {type RotationCandidate} from '@/Types/Periods/Rotations/RotationCandidate'

export const getRotationParticipantStatusColor = (rotation:RotationCandidate|RotationVoter):Color => {
	if(rotation.is_pending){
		return Color.Yellow
	}
	if(rotation.is_accepted){
		return Color.Green
	}
	if(rotation.is_elected){
		return Color.Teal
	}
	if(rotation.is_admitted){
		return Color.Sky
	}
	if(rotation.is_rejected){
		return Color.Red
	}
	return Color.Neutral
}